var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, customElement } from "lit-element";
import styles from "./style";
import './components/status-fetch-element';
let StatusApp = class StatusApp extends LitElement {
    render() {
        return html `
      <div class="container">
        <h1 class="header">${APP_TITLE}</h1>
        <status-fetch-element fetchUrl="${SOURCE_URL}"></status-fetch-element>
      </div>
    `;
    }
};
StatusApp.styles = styles;
StatusApp = __decorate([
    customElement('status-app')
], StatusApp);
const app = document.createElement('status-app');
document.body.appendChild(app);
